export default "/cars-for-sale/(advanced-search|index.xhtml)?";